<template>
  <CModal
    :title="title"
    color="info"
    :show="show"
    :centered="true"
    class="edit-roles-modal"
    @update:show="handleCancel"
  >
    <div>
      <div class="modal-title">
        <h2 class="">{{ title }}</h2>
        <i v-if="loading" class="fa fa-cog fa-spin fa-2x"></i>
      </div>

      <div v-if="errors.length" class="my-3">
        <CAlert
          v-for="(error, index) in errors"
          :key="`error-${index}`"
          :show="90"
          color="danger"
          closeButton
        >
          {{ error }}
        </CAlert>
      </div>

      <CRow>
        <CCol col="12">
          <CSelect
            :value="null"
            @update:value="handleSelectRole"
            :options="availableRoles"
          />

          <div
            v-for="(role, index) in internalRoles"
            :key="`role-${index}`"
            class="role"
          >
            <div class="role__field">{{ role.name }}</div>
            <div class="role__remove" @click="handleRoleRemove(role)">
              &times;
            </div>
          </div>
        </CCol>
      </CRow>
    </div>

    <template #footer>
      <CButton @click="handleCancel" color="secondary">Cancel</CButton>
      <CButton @click="handleSave" color="success">Save</CButton>
    </template>
  </CModal>
</template>

<script>
// import { mapActions } from 'vuex'
// import sortBy from 'lodash-es/sortBy'
import { mapActions } from "vuex";
import getNested from "lodash-es/get";
import cloneDeep from "lodash-es/cloneDeep";

export default {
  name: "edit-roles-modal",

  components: {},

  props: {
    show: {
      type: Boolean,
      default: false,
    },

    title: {
      type: String,
      default: "Roles",
    },

    organization: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      loading: false,
      errors: [],
      internalRoles: [],
    };
  },

  async mounted() {
    await this.getRoles(); // sync roles to $state.roles
  },

  methods: {
    ...mapActions(["getRoles"]),
    ...mapActions("users", ["updateRoles", "updateOrg"]),

    handleCancel() {
      this.$emit("update:show", false);
    },

    async handleSave(evt) {
      if (evt) {
        evt.preventDefault();
      }

      this.loading = true;

      const roles = this.internalRoles.map((item) => item.value);
      //await this.updateRolesInternal(roles); Disabled as this update is moved to backend
      await this.updateRolesAuth0(roles);

      if (!this.errors) {
        this.$emit("updated");
        this.$emit("update:show", false);
      }
      this.loading = false;
    },

    async updateRolesAuth0(roles) {
      const response = await this.updateRoles({
        orgId: getNested(this.organization, "organizationId"),
        roles: roles,
      });

      if (response.error) {
        const errorText = getNested(
          response,
          "error_details.message",
          "Unknown error"
        );
        this.errors.push(`Can't save roles! "${errorText}"`);
      }
    },

    async updateRolesInternal(roles) {
      const response = await this.updateOrg({
        ...this.organization,
        accessRoleId: roles,
      });

      if (response.error) {
        const errorText = getNested(
          response,
          "error_details.message",
          "Unknown error"
        );
        this.errors.push(`Can't save roles! "${errorText}"`);
      }
    },

    handleSelectRole(roleId) {
      const role = this.allRoles.find((item) => item.value === roleId);

      if (role) {
        this.internalRoles.push(cloneDeep(role));
      }
    },

    handleRoleRemove(role) {
      this.internalRoles = this.internalRoles.filter(
        (item) => item.value !== role.value
      );
    },
  },

  computed: {
    allRoles() {
      return getNested(this.$store, "state.roles", []);
    },

    availableRoles() {
      const internalRoleIds = this.internalRoles.map((item) => item.value);
      return getNested(this.$store, "state.roles", []).filter(
        (item) => !internalRoleIds.includes(item.value)
      );
    },
  },

  watch: {
    show() {
      const roles = getNested(
        this.organization,
        "accessRoleId",
        []
      ).map((roleId) => this.allRoles.find((item) => item.value === roleId));
      this.internalRoles = cloneDeep(roles);
      this.errors = [];
    },
  },
};
</script>

<style scoped lang="scss">
.edit-roles-modal {
  .modal-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;

    .fa-cog {
      color: #adadad;
    }
  }

  .role {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 10px;

    &:hover {
      background-color: #e8e8e8;
    }

    &__remove {
      font-size: 30px;
      line-height: 35px;
      font-weight: bold;
      color: #9a0000;
      cursor: pointer;
    }

    &__remove:hover {
      color: #bd0404;
    }
  }
}
</style>
